import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UNA from '../theme';
import logoUNA from '../assets/logo_una.jpg';

const usuariosPrueba = [
  { id: 1, nombre: 'Admin UNA', email: 'admin@una.cr', password: '1234', rol: 'admin' },
  { id: 2, nombre: 'Prof. Juan Mora', email: 'juan@una.cr', password: '1234', rol: 'instructor' },
  { id: 3, nombre: 'Josue Lizano', email: 'josue@una.cr', password: '1234', rol: 'alumno' },
];

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async () => {
  if (!email || !password) { setError('Completá todos los campos'); return; }
  try {
    const usuario = await login(email, password);
    if (usuario.rol === 'admin') navigate('/admin');
    else if (usuario.rol === 'instructor') navigate('/instructor');
    else navigate('/');
  } catch (err) {
    setError(err.message || 'Correo o contraseña incorrectos');
  }
};

  return (
    <div style={{ minHeight: '100vh', background: `linear-gradient(135deg, #1a1a2e 0%, ${UNA.rojo} 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Segoe UI, sans-serif' }}>
      <div style={{ background: 'white', borderRadius: '20px', padding: '2.5rem', width: '100%', maxWidth: '420px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img src={logoUNA} alt="Logo UNA" style={{ width: '160px', margin: '0 auto 1rem', display: 'block' }} />
          <h2 style={{ color: UNA.texto, margin: '0 0 4px', fontSize: '22px', fontWeight: '700' }}>Talleres UNA</h2>
          <p style={{ color: '#888', margin: 0, fontSize: '13px' }}>Campus Coto · Corredor, Puntarenas</p>
        </div>

        {/* Formulario */}
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px', fontWeight: '500' }}>Correo institucional</label>
          <input value={email} onChange={e => { setEmail(e.target.value); setError(''); }}
            placeholder="usuario@una.cr"
            style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #e0e0e0', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}
            onFocus={e => e.target.style.borderColor = UNA.rojo}
            onBlur={e => e.target.style.borderColor = '#e0e0e0'} />
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px', fontWeight: '500' }}>Contraseña</label>
          <input value={password} onChange={e => { setPassword(e.target.value); setError(''); }}
            type="password" placeholder="••••••••"
            style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #e0e0e0', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}
            onFocus={e => e.target.style.borderColor = UNA.rojo}
            onBlur={e => e.target.style.borderColor = '#e0e0e0'}
            onKeyDown={e => e.key === 'Enter' && handleLogin()} />
        </div>

        {error && (
          <div style={{ background: UNA.rojoClaro, border: `1px solid ${UNA.rojo}`, borderRadius: '8px', padding: '10px 14px', marginBottom: '1rem', color: UNA.rojo, fontSize: '13px', textAlign: 'center' }}>
            {error}
          </div>
        )}

        <button onClick={handleLogin}
          style={{ width: '100%', background: UNA.rojo, color: 'white', border: 'none', padding: '13px', borderRadius: '10px', fontSize: '15px', fontWeight: '600', cursor: 'pointer' }}
          onMouseEnter={e => e.target.style.background = UNA.rojoOscuro}
          onMouseLeave={e => e.target.style.background = UNA.rojo}>
          Ingresar
        </button>

        {/* Usuarios de prueba */}
        <div style={{ marginTop: '1.5rem', background: '#fafafa', borderRadius: '10px', padding: '1rem', border: '1px solid #f0f0f0' }}>
          <p style={{ fontSize: '11px', color: '#aaa', margin: '0 0 10px', fontWeight: '700', letterSpacing: '0.5px' }}>USUARIOS DE PRUEBA — clic para autocompletar</p>
          {usuariosPrueba.map(u => (
            <div key={u.id} onClick={() => { setEmail(u.email); setPassword(u.password); setError(''); }}
              style={{ fontSize: '13px', color: '#444', padding: '6px 8px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: '6px' }}
              onMouseEnter={e => e.currentTarget.style.background = '#f0f0f0'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
              <span>{u.email}</span>
              <span style={{
                fontSize: '11px', fontWeight: '600', padding: '2px 10px', borderRadius: '12px',
                background: u.rol === 'admin' ? UNA.rojoClaro : u.rol === 'instructor' ? '#fff8e1' : '#e8f5e9',
                color: u.rol === 'admin' ? UNA.rojo : u.rol === 'instructor' ? '#e65100' : '#2e7d32'
              }}>{u.rol}</span>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default Login;